// Danh sach tai khoan duoc phep dung he thong.
//
// Khong co danh sach nay thi bat ky ai dang nhap duoc panel - ke ca nguoi
// ngoai to - deu tu dang ky duoc va xai chung kho API key.

import { useEffect, useState } from "react";
import { api } from "../api";
import { Alert, Badge, ErrorBox, Spinner, Switch } from "../components/ui";
import type { ChoPhep } from "../types";

export default function ChoPhepCard() {
  const [cp, setCp] = useState<ChoPhep | null>(null);
  const [duocSua, setDuocSua] = useState(false);
  const [khongGo, setKhongGo] = useState<string[]>([]);
  const [them, setThem] = useState("");
  const [loi, setLoi] = useState<unknown>(null);
  const [dangLuu, setDangLuu] = useState(false);
  const [daLuu, setDaLuu] = useState(false);

  const nap = () => {
    api
      .choPhep()
      .then((r) => {
        setCp(r.cho_phep);
        setDuocSua(r.duoc_sua);
        setKhongGo(r.khong_go_duoc);
      })
      .catch(setLoi);
  };
  useEffect(nap, []);

  const luu = async (moi: ChoPhep) => {
    setDangLuu(true);
    setLoi(null);
    try {
      const r = await api.luuChoPhep(moi);
      setCp(r.cho_phep);
      setDaLuu(true);
      window.setTimeout(() => setDaLuu(false), 2500);
    } catch (e) {
      setLoi(e);
      nap(); // tra ve trang thai that, dung de man hinh hien sai
    } finally {
      setDangLuu(false);
    }
  };

  if (!cp) return <div className="card-body"><Spinner /></div>;

  const themTaiKhoan = () => {
    const t = them.trim();
    if (!t) return;
    setThem("");
    void luu({ ...cp, danh_sach: [...cp.danh_sach, t] });
  };

  return (
    <div className="card" style={{ marginTop: 16 }}>
      <div className="card-head">
        <h2 className="grow">Tài khoản được phép dùng</h2>
        {daLuu ? <Badge tone="ok">Đã lưu</Badge> : null}
        <Badge tone={cp.bat ? "ok" : "danger"}>
          {cp.bat ? `${cp.danh_sach.length} tài khoản` : "Đang mở cho tất cả"}
        </Badge>
      </div>

      <div className="card-body">
        {cp.bat ? (
          <Alert tone="info">
            Chỉ những tài khoản dưới đây đăng nhập và thiết lập được. Người ngoài
            danh sách bị từ chối <strong>trước khi</strong> hệ thống mở phiên
            trình duyệt, nên không tốn tài nguyên máy chủ.
          </Alert>
        ) : (
          <Alert tone="danger">
            Danh sách đang tắt. <strong>Bất kỳ ai</strong> đăng nhập được vào
            Techniverse Panel — kể cả người ngoài tổ — đều tự tạo được tài khoản
            ở đây và dùng chung kho API key của bạn.
          </Alert>
        )}

        <div style={{ margin: "14px 0" }}>
          <Switch
            checked={cp.bat}
            disabled={!duocSua || dangLuu}
            onChange={(v) => void luu({ ...cp, bat: v })}
            label="Chỉ cho phép tài khoản trong danh sách"
          />
        </div>

        {cp.danh_sach.length === 0 ? (
          <div className="muted small">Danh sách trống.</div>
        ) : (
          <div className="row wrap" style={{ gap: 7 }}>
            {cp.danh_sach.map((t) => {
              const co_dinh = khongGo.includes(t);
              return (
                <span
                  key={t}
                  className="badge"
                  style={{ padding: "5px 6px 5px 11px", fontSize: 12.5 }}
                  title={co_dinh ? "Tài khoản quản trị, không gỡ được" : undefined}
                >
                  {t.toUpperCase()}
                  {co_dinh ? (
                    <span className="muted" style={{ marginLeft: 5 }}>⚿</span>
                  ) : duocSua ? (
                    <button
                      className="btn btn-sm btn-ghost"
                      style={{ padding: "0 4px", marginLeft: 3, lineHeight: 1 }}
                      disabled={dangLuu}
                      onClick={() =>
                        void luu({
                          ...cp,
                          danh_sach: cp.danh_sach.filter((x) => x !== t),
                        })
                      }
                      title={`Gỡ ${t.toUpperCase()}`}
                    >
                      ✕
                    </button>
                  ) : null}
                </span>
              );
            })}
          </div>
        )}

        {loi ? <div style={{ marginTop: 12 }}><ErrorBox error={loi} /></div> : null}

        {duocSua ? (
          <div className="row" style={{ marginTop: 14 }}>
            <input
              className="input grow"
              style={{ maxWidth: 260 }}
              placeholder="Thêm tài khoản, ví dụ CSCN16"
              value={them}
              onChange={(e) => setThem(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && themTaiKhoan()}
            />
            <button
              className="btn btn-primary"
              onClick={themTaiKhoan}
              disabled={!them.trim() || dangLuu}
            >
              {dangLuu ? <Spinner /> : null} Thêm
            </button>
          </div>
        ) : (
          <div className="hint" style={{ marginTop: 12 }}>
            Chỉ tài khoản quản trị sửa được danh sách này.
          </div>
        )}
      </div>
    </div>
  );
}
